import CryptoJS from 'crypto-js';

const base64URLEncode = (words: any) => CryptoJS.enc.Base64.stringify(words)
  .replace(/\+/g, '-')
  .replace(/\//g, '_')
  .replace(/=/g, '');

const verifier = () => base64URLEncode(CryptoJS.lib.WordArray.random(32));

const challenge = (word: string) => base64URLEncode(CryptoJS.SHA256(word));

export default { verifier, challenge, base64URLEncode };
